import { BellOutlined } from "@ant-design/icons";
import { Badge, Button, Popover } from "antd";

const NotificationsComponent = ({ count, renderHeader, renderBody }) => (
  <Popover
    trigger={"click"}
    placement="bottomRight"
    title={renderHeader}
    content={renderBody}
  >
    <Badge count={count}>
      <Button icon={<BellOutlined />} />
    </Badge>
  </Popover>
);

export default NotificationsComponent;
